<mat-form-field id="label">
  <input matInput [value]="label" readonly tabindex="-1" />
</mat-form-field>
<mat-form-field id="value">
  <input matInput [value]="value  | currency:'BRL':true " readonly tabindex="-1" />
</mat-form-field>
